import React from 'react';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

function CaseStudyNextSteps() {
  return (
    <>
      <Box
        component='section'
        aria-labelledby='capability-statement'
        sx={{ mt: 6 }}
      >
        <Typography
          id='capability-statement'
          component='h2'
          variant='h5'
          sx={{ fontWeight: 700 }}
        >
          Explore our CMS capabilities
        </Typography>
        <Typography sx={{ mt: 2, color: '#475569' }}>
          Review our approach to accessibility, permissions, integrations, deployment, and support
          in the CMS capability statement.
        </Typography>
        <Button
          href='/cms-capabilities'
          data-track='capability_statement'
          endIcon={<ArrowForwardIcon />}
          sx={{ mt: 1 }}
        >
          View CMS capability statement
        </Button>
      </Box>

      <Box sx={{ mt: 6, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2 }}>
        <Typography
          variant='h6'
          component='h2'
          sx={{ fontWeight: 700 }}
        >
          Have a publishing workflow to improve?
        </Typography>
        <Button
          component={Link}
          to='/contact-us'
          endIcon={<ArrowForwardIcon />}
        >
          Contact us
        </Button>
      </Box>
    </>
  );
}

export default CaseStudyNextSteps;
